import "./tick";
import { Game } from "..";
import { mapValues } from "../../lib/util";

// Register generic event deserializer
// Converts serialized event data to GameEvents format:
// - Keys ending in 'Uids' (e.g., itemUids) → resolved items array (e.g., items)
// - Other keys pass through unchanged
Game.registerGeneralEventDeserializer(function (event, data) {
  return mapValues(data, (value, key) => {
    switch (key) {
    }
    return value;
  });
});

Game.registerEventDeserializers({
  "merge:execute"(_deserialized, serialized) {
    const connectedItems = serialized.connectedItemUids
      .map((uid) => this.state.items.get(uid))
      .filter(Boolean);
    const spawn = serialized.spawn
      .map(({ itemId, tileKey }) => {
        const tile = this.state.tiles.get(tileKey);
        return tile ? { itemId, tile } : null;
      })
      .filter(Boolean);
    if (connectedItems.length === 0 || spawn.length === 0) return null;
    return { connectedItems, spawn } as any;
  },
  "merge:spawn"(_deserialized, serialized) {
    const connectedItems = serialized.connectedItemUids
      .map((uid) => this.state.items.get(uid))
      .filter(Boolean);
    const spawn = serialized.spawn
      .map(({ itemId, tileKey }) => {
        const tile = this.state.tiles.get(tileKey);
        return tile ? { itemId, tile } : null;
      })
      .filter(Boolean);
    if (connectedItems.length === 0 || spawn.length === 0) return null;
    return { connectedItems, spawn, center: serialized.center } as any;
  },
  "merge:complete"(_deserialized, serialized) {
    const spawnedItems = serialized.spawnedItemUids
      .map((uid) => this.state.items.get(uid))
      .filter(Boolean);
    if (spawnedItems.length === 0) return null;
    return { spawnedItems } as any;
  },
});
